import request from '@/utils/request'

const MOCK_USER = {
  id: 1,
  username: 'admin',
  name: '系统管理员',
  avatar: '',
  roles: ['admin']
}

function mockResolve(data, delay = 450) {
  return new Promise(resolve => window.setTimeout(() => resolve(data), delay))
}

function mockReject(message, delay = 450) {
  return new Promise((resolve, reject) => {
    window.setTimeout(() => reject(new Error(message)), delay)
  })
}

export function login(data) {
  if (process.env.VUE_APP_USE_MOCK === 'true') {
    if (data.identity === 'admin' && data.password === 'admin123') {
      return mockResolve({ token: `mock-token-${Date.now()}`, user: MOCK_USER })
    }
    return mockReject('账号或密码错误')
  }
  return request.post('/account/login', {
    agentId: Number(process.env.VUE_APP_AGENT_ID || 1),
    account: data.mode === 'account' ? data.identity : '',
    phone: data.mode === 'phone' ? data.identity : '',
    password: data.password,
    platform: 2
  }).then(result => normalizeLoginResult(result, data.identity))
}

export function normalizeLoginResult(result, identity = '') {
  return {
    ...result,
    user: {
      id: result.userId,
      username: result.userName || identity,
      name: result.nickName || result.userName || identity || '微信用户',
      avatar: '',
      roles: ['admin']
    }
  }
}

export function getWechatLoginQrCode() {
  return request.post('/account/getwxsmallloginqrcode', {
    agentId: Number(process.env.VUE_APP_AGENT_ID || 1),
    path: 'pages/authLogin/authLogin',
    env_version: 'release'
  })
}

export function getWechatLoginStatus(scene) {
  return request.get('/account/getwxsmallloginqrcodestate', {
    params: { scene },
    silent: true
  })
}

export function getUserInfo() {
  if (process.env.VUE_APP_USE_MOCK === 'true') return mockResolve(MOCK_USER, 250)
  return request.post('/account/getuserinfo').then(data => ({
    id: data.userId,
    username: data.userName,
    name: data.nickName || data.userName,
    avatar: data.avatarUrl || '',
    roles: ['admin']
  }))
}

export function logout() {
  if (process.env.VUE_APP_USE_MOCK === 'true') return mockResolve(null, 200)
  return Promise.resolve(null)
}
